import React from 'react';
const stats = [{
  value: '+500',
  label: 'Familias felices'
}, {
  value: '12',
  label: 'Tomos listos'
}, {
  value: '5',
  label: 'Bonos incluidos'
}, {
  value: '4.9/5',
  label: 'Calificación ⭐'
}];
export function Stats() {
  return <section aria-label="Resultados reales" className="border-y border-white/5 bg-ink-2" data-id="element-139" data-mp="2ixpbkr5zj10b">
      <div className="mx-auto max-w-5xl px-5 pt-[0px] pb-[0px]" data-id="element-140" data-mp="2nvh1jfn2kd1v">
        <dl className="grid grid-cols-2 gap-6 pt-[8px] pb-[7px] sm:grid-cols-4" data-id="element-141" data-mp="297mcc989sqtj">
          {stats.map(s => <div key={s.label} className="text-center" data-id="element-142" data-mp="2dzw660ciab13">
              <dt className="font-display text-4xl font-black text-white sm:text-5xl" data-id="element-143" data-mp="207fz8oghhsuw">{s.value}</dt>
              <dd className="mt-1 text-sm font-medium text-white/60" data-id="element-144" data-mp="256k6vanrfij4">{s.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}